import {
	Box,
	Flex,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalHeader,
	ModalOverlay,
} from "@chakra-ui/react";
import { useCallback } from "react";
import { useMutation, useQueryClient } from "react-query";
import { changeCommandStatus } from "../../mutations/command.mutations";
import PenIcon from "../icons/PenIcon";
import DeleteOrderForm from "../forms/DeleteOrderForm";
import { CommandStatus } from "../../types/command.types";

type DeleteOrderModalProps = {
	orderId: number;
	isOpen: boolean;
	onOpen: () => void;
	onClose: () => void;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function DeleteOrderModal({
	orderId,
	isOpen,
	onOpen: _,
	onClose,
}: DeleteOrderModalProps) {
	const { mutate: mutateCommandStatus } = useMutation(changeCommandStatus);
	const queryClient = useQueryClient();
	const handleSubmit = useCallback(
		(data: { status: string; explanation: string }) => {
			mutateCommandStatus(
				{
					id: orderId,
					status: CommandStatus.ABORTED,
					reason: CommandStatus.ABORTED,
					explanation: data.explanation,
				},
				{
					onSettled: () => {
						queryClient.invalidateQueries("command");
						queryClient.invalidateQueries("commands");
						onClose();
					},
				},
			);
		},
		[orderId, mutateCommandStatus, onClose],
	);
	return (
		<Modal isOpen={isOpen} onClose={onClose} isCentered>
			<ModalOverlay bg="blackAlpha.300" backdropFilter="blur(6.9px)" />
			<ModalContent maxW={"none"} w="600px">
				<ModalHeader borderBottom="solid 1px #E2E8F0">
					<Flex>
						<Flex
							w="48px"
							h="48px"
							bg="zinc.50"
							border="solid 1px"
							borderColor="brand.100"
							justifyContent="center"
							alignItems="center"
							borderRadius={100}
							mr="8px"
						>
							<PenIcon w="24px" h="24px" color="red"></PenIcon>
						</Flex>
						<Box lineHeight="48px">Annuler la commande</Box>
					</Flex>
				</ModalHeader>
				<ModalCloseButton onClick={onClose} />
				<ModalBody>
					<DeleteOrderForm
						id={orderId}
						onClose={onClose}
						onSubmit={handleSubmit}
					></DeleteOrderForm>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
}

export default DeleteOrderModal;
